var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6214_569)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.73991 1.43066C6.49118 1.43066 6.28955 1.6323 6.28955 1.88102V2.78369L9.70361 2.78369V1.88103C9.70361 1.6323 9.50198 1.43066 9.25325 1.43066H6.73991ZM5.53955 1.88102V2.78369L1.34033 2.78369C1.13323 2.78369 0.965332 2.95158 0.965332 3.15869C0.965332 3.3658 1.13323 3.53369 1.34033 3.53369H2.07959V14.7052C2.07959 15.7962 2.96404 16.6807 4.05506 16.6807H11.9039C12.995 16.6807 13.8794 15.7962 13.8794 14.7052L13.8792 3.53369H14.6597C14.8668 3.53369 15.0347 3.3658 15.0347 3.15869C15.0347 2.95159 14.8668 2.78369 14.6597 2.78369L10.4536 2.78369V1.88103C10.4536 1.21808 9.91619 0.680664 9.25325 0.680664H6.73991C6.07697 0.680664 5.53955 1.21808 5.53955 1.88102ZM6.00042 5.75736C5.72237 5.75736 5.49697 5.98276 5.49697 6.26081V12.9233C5.49697 13.2014 5.72237 13.4268 6.00042 13.4268C6.27847 13.4268 6.50387 13.2014 6.50387 12.9233V6.26081C6.50387 5.98276 6.27847 5.75736 6.00042 5.75736ZM10.0004 5.75736C9.72235 5.75736 9.49695 5.98276 9.49695 6.26081V12.9233C9.49695 13.2014 9.72235 13.4268 10.0004 13.4268C10.2784 13.4268 10.5038 13.2014 10.5038 12.9233V6.26081C10.5038 5.98276 10.2784 5.75736 10.0004 5.75736Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6214_569"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.680664)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.ae91d58f93770ebb403d05fdeff74c47.svg";
export { ForwardRef as ReactComponent };